import PropTypes from 'prop-types';
import { Pin } from 'lucide-react';

import { cn } from '#/lib/utils';
import { Button } from '#/modules/commonComponents/button';
import { useSideMsgDock } from '#/modules/commonComponents/SideMsgDockContext';
import { SIDE_MSG_DOCK_MODE } from '#/utils/userSideMsgPrefsStorage';

const ICON_CLASS = 'size-4';

/**
 * SideMsg 標題列釘選（僅 enableDockModes 且 ≥ xl 顯示）。
 */
const SideMsgDockTitleActions = ({ className }) => {
  const { enableDockModes, mode, toggleMode } = useSideMsgDock();
  const isPinned = mode === SIDE_MSG_DOCK_MODE.PINNED;

  if (!enableDockModes) {
    return null;
  }

  return (
    <div className={cn('side_msg_title-actions', className)}>
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        aria-label={isPinned ? '改為浮動' : '釘選側欄'}
        aria-pressed={isPinned}
        onClick={toggleMode}
      >
        <Pin className={cn(ICON_CLASS, isPinned && 'fill-current')} aria-hidden />
      </Button>
    </div>
  );
};

SideMsgDockTitleActions.propTypes = {
  className: PropTypes.string,
};

export default SideMsgDockTitleActions;
